import 'vuetify/styles';
import { createVuetify } from 'vuetify';

export default createVuetify({
  theme: {
    themes: {
      light: {
        colors: {
          error: '#FF5252',
        },
      },
      dark: {
        colors: {
          error: '#FF5252',
        },
      },
    },
  },
  defaults: {
    VAutocomplete: { hideDetails: 'auto', variant: 'outlined' },
    VBtn: { variant: 'flat' },
    VCombobox: { hideDetails: 'auto', variant: 'outlined' },
    VRadioGroup: { hideDetails: 'auto' },
    VSelect: { hideDetails: 'auto', variant: 'outlined' },
    VSwitch: { color: 'primary', hideDetails: 'auto' },
    VTextarea: { hideDetails: 'auto' },
    VTextField: { hideDetails: 'auto', variant: 'outlined' },
    VToolbar: { VBtn: { variant: 'flat' } },
    VTooltip: { location: 'bottom' },
  },
});
